import "../bootstrap.min.css";
import "../style.css";
import "../responsive.css";
import "../custom.css";

export default function PriceBadge(props) {

  return (
    <>
      {/* {props.isFree || props.text === "0.00" ? ( */}
      {props.serviceProvider === 53 ? (
        <div
          style={{
            top: "8px",
            right: "8px",
            color: "#808080",
            padding: "4px 8px",
            borderRadius: "6px",
            fontSize: "12px",
            fontWeight: "600",
            textAlign: "center",
            width: "fit-content",
            minWidth: "65px",
            border: "1px solid #808080",
            whiteSpace: "nowrap",
          }}
        >
          {" "}
          YOU PAY
        </div>
      ) : (
        <div
          style={{
            top: "8px",
            right: "8px",
            border: "1px solid #808080",
            color: "#808080",
            padding: "4px 8px",
            borderRadius: "6px",
            fontSize: "12px",
            fontWeight: "600",
            textAlign: "center",
            width: "fit-content",
            minWidth: "65px",
            whiteSpace: "nowrap",
          }}
          dangerouslySetInnerHTML={{
            __html: props.text,
          }}
          
        />
      )}
    </>
  );
}
